/* eslint-disable */
import fv from './_fv';
import pmt from './_pmt';

function cumipmt(rate, periods, value, start, end, type) {

  // Compute cumulative interest
  const payment = pmt(rate, periods, value, 0, type);

  let cumipmtInterest = 0;

  if (start === 1) {
    if (type === 0) {
      cumipmtInterest = -value;
      start++;
    }
  }

  for (let i = start; i <= end; i = i + 1) {

    if (type === 1) {
      cumipmtInterest += fv(rate, i - 2, payment, value, 1) - payment;
    } else {
      cumipmtInterest += fv(rate, i - 1, payment, value, 0);
    }

  }

  cumipmtInterest *= rate;

  cumipmtInterest = Math.ceil(cumipmtInterest * 100) / 100;

  return -cumipmtInterest;

}

export default cumipmt;
